import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=0543d4c5&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=0543d4c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543d4c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0543d4c5')) {
      api.createRecord('0543d4c5', component.options)
    } else {
      api.reload('0543d4c5', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=0543d4c5&scoped=true&", function () {
      api.rerender('0543d4c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedback/Feedback.vue"
export default component.exports